module.exports = __webpack_public_path__ + "static/media/loyalty_rewards-mb-fr.287cd7b3.jpg";